


































































import { Vue, Component, Prop, p } from "av-ts";
import { IRecommendedRole } from "../../interfaces/models";

@Component
export default class RoleChip extends Vue {
    @Prop role = p<IRecommendedRole>({
        required: true
    });

    @Prop disabled = p<boolean>({
        required: false,
        default: false
    });

    get studyRole(): String {
        switch (this.role.studyRole.id) {
        case 1:
            return "md-primary";
        case 2:
            return "md-accent";
        case 3:
            return "md-warn";
        default:
            return "";
        }
    }

    get status() {
        return {
            disabled: this.disabled,
            selected: !this.disabled
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/peers/RoleChip.vue